export default __webpack_public_path__ + "static/5-a92234d31ddc1f9b235e046e0191296c.png";